/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { filter$ } from '@gh/rx/operators';

import { isNil, noop } from 'lodash';

import { BuilderAuthNumberService } from '../../../services/builder-auth-number.service';

export type AuthNumberReceivedEvent = {
  token: string;
};

@Component({
  standalone: false,
  selector: 'gh-auth-number-request',
  templateUrl: 'auth-number-request.component.html',
  styleUrls: ['auth-number-request.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: AuthNumberRequestComponent,
    multi: true,
  }],
})
export class AuthNumberRequestComponent implements ControlValueAccessor {
  @Input() entryPoint: string;

  @Output() received = new EventEmitter<AuthNumberReceivedEvent>();

  disabled: boolean = false;

  private onChange: (value: unknown) => void = noop;

  constructor(private authNumberService: BuilderAuthNumberService) {
  }

  writeValue(token: string): void {
    this.disabled = !isNil(token);
  }

  registerOnChange(fn: (value: unknown) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    // nothing to do
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /**
   * Opens Authorization Number dialog and provides further actions.
   * - Sets privilegedToken to form
   * - Disables request token button
   * - Invokes form action.
   * @important Form MUST implements FormAuthNumberable interface
   */
  openRequestDialog(): void {
    this.authNumberService.openAuthNumberRequest(this.entryPoint).pipe(
      filter$(Boolean))
      .subscribe((token: any) => {
        this.disabled = true;
        this.onChange(token);
        this.received.emit({ token });
      });
  }
}
